import { Chip, Stack, Typography } from "@mui/material";
import ColorSwatch from "../ColorSwatch";
import type { ValueOption } from "./axisValueLabels";

// `fullWidth` is for a MenuItem caller, so the severity text lands at the
// row's far edge - inline uses leave it at content width instead.
export default function ValueOptionContent({
  option,
  fullWidth,
}: {
  option: ValueOption;
  fullWidth?: boolean;
}) {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ alignItems: "center", width: fullWidth ? "100%" : undefined }}
    >
      {option.color && <ColorSwatch color={option.color} size={12} />}
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", flexGrow: 1 }}>
        {option.name && <Typography variant="body2">{option.name}</Typography>}
        <Chip label={option.value} size="small" variant="outlined" />
      </Stack>
      {option.severityLabel && (
        <Typography variant="caption" color="text.secondary">
          {option.severityLabel}
        </Typography>
      )}
    </Stack>
  );
}
